import { render, staticRenderFns } from "./CadProcessosAtaDirex.vue?vue&type=template&id=6c4bc29a"
import script from "./CadProcessosAtaDirex.vue?vue&type=script&lang=js"
export * from "./CadProcessosAtaDirex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports